import { AbstractControlOptions, AsyncValidatorFn, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { INameId } from '@modeso/types__aumico-lib-core-be';

export class RadioFormControl extends UntypedFormControl {
    /** the list of radio options */
    private radioOptions: INameId[] = [];

    /**
     * @param radioOptions - an array containing the valid control options. A control option has an id and a name.
     * @param compareFn - a function that compares two control option values
     * @param formState - the state of the form control.
     * @param validatorOrOpts - any synchronous validator or option
     * @param asyncValidator - any asynchronous validator
     */
    constructor(
        radioOptions: INameId[],
        private compareFn: (c1: INameId, c2: INameId) => boolean,
        formState?: any,
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[],
    ) {
        super(formState, validatorOrOpts, asyncValidator);
        this.radioOptions = radioOptions;
        this.setNormalizedValue(this.value);
    }

    /** Overrides the setValue method with one that will normalize the value first */
    public override setValue(key: INameId) {
        this.setNormalizedValue(key);
    }

    /** Looks up the proposed value in the list of valid options using the compare function specified in the constructor.
     *  If found, sets the internal value of the form control to the object from the list which matches the proposed value.
     *  That way the object reference is always the same. If the value is not found the list,
     *  the formcontrol will use the proposed object as a value but since it is not in the option list none of the radio buttons will be selected.
     */
    private setNormalizedValue(key: INameId): void {
        let v = this.radioOptions.filter((v) => this.compareFn(v, key));
        if (v && v.length > 0) {
            this.proxySetValue(v[0]);
        } else {
            // the value was not in the options list
            this.proxySetValue(key);
        }
    }

    /** Sets the value on the super class (the internal formcontrol value) */
    private proxySetValue(key: INameId): void {
        super.setValue(key);
    }
}
